/*
 *
 * Login Utils
 *
 */
import { getAppConfigSetting } from 'utils';

const HOSTNAME_URL = `https://${window.location.host}/cashiering`;

export const oktaConfig = {
  baseUrl: getAppConfigSetting('oktaUrl'),

  redirectUri: HOSTNAME_URL,
  clientId: getAppConfigSetting('clientId'),
  signOutLink: HOSTNAME_URL,
  authParams: {
    pkce: true,
    issuer: getAppConfigSetting('oktaIssuer'),
    scopes: ['openid', 'email', 'profile'],
    postLogoutRedirectUri: HOSTNAME_URL,
  },
  features: {
    idpDiscovery: true,
  },
  idpDiscovery: {
    requestContext: getAppConfigSetting('oktaIdpDiscovery'),
  },
  logo: false,
  i18n: {
    en: {
      'primaryauth.title': 'Sign In ',
      'primaryauth.username.placeholder': 'E-mail Address *',
      'primaryauth.password.placeholder': 'Password *',
      'error.username.required': 'Please enter an e-mail address',
      'error.password.required': 'Please use your Okta password',
      'oform.error.unexpected': 'Please use your e-mail address and Okta password',
      'primaryauth.submit': 'Sign In',
    },
  },
};



// WEBPACK FOOTER //
// ./src/utils/okta-config.js